import React from 'react'
import { Link } from '@inertiajs/react'
import PortfolioLayout from '@/layouts/PortfolioLayout'
import { ArrowLeft } from 'lucide-react'
import type { SharedProps } from '@/types/shared'

// Guides are global (served at /guides) and property-agnostic, so they render inside the
// portfolio chrome. currentAccount/canManageBilling come from usePage inside PortfolioLayout,
// so guide pages only thread currentUser + properties.
interface GuideLayoutProps extends Pick<SharedProps, 'currentUser' | 'properties'> {
  title: string
  subtitle: string
  children: React.ReactNode
}

// The guide's own heading doubles as its tab title — one string, so the tab and the <h1> can
// never disagree, and all 16 guide pages needed no edit at all.
export default function GuideLayout({ currentUser, properties, title, subtitle, children }: GuideLayoutProps) {
  return (
    <PortfolioLayout currentUser={currentUser} properties={properties} title={title}>
      <div className="mx-auto max-w-3xl space-y-8">
        <div className="animate-slide-in" style={{ animationDelay: '0ms' }}>
          <Link
            href="/guides"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Help & Guides
          </Link>
        </div>

        <div className="animate-slide-in" style={{ animationDelay: '50ms' }}>
          <h1 className="text-xl font-bold tracking-tight text-foreground">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
        </div>

        <div className="animate-slide-in space-y-8" style={{ animationDelay: '100ms' }}>
          {children}
        </div>
      </div>
    </PortfolioLayout>
  )
}
